import {
    DropdownContent as BaseDropdownContent,
    DropdownContentProps as BaseDropdownContentProps
} from "@/templates/software/jira/service-management/jira-service-management-software-page/src/sections/software-jira-service-management-navbarv2.tsx";

// todo: GWP-8381 move the base imports to this file
export const DropdownContent = BaseDropdownContent;
export type DropdownContentProps = BaseDropdownContentProps;
